import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import { isCompanyCountryFrance } from '@/lib/country/entityCountries'
import { routeFrontOfficeAllEntityGroupementChainCommon } from '@/lib/routes/front_groupement/common/routeFrontOfficeAllEntityGroupementChainCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

/**
 * Menu « MA CENTRALE » de l'espace groupement (module Store) — meme mecanique que
 * « Ma radio » / « Mes formations » : un jeu de routes porte par l'ENTITE Store et un role
 * dynamique calcule par l'API. En menu v2, deriveMenuGroupV2 en fait la section « Ma centrale »
 * (libelle de l'entite), a cote de « Mon groupement ».
 *
 * Le role ROLE_DYNAMIC_ROUTE_STORE_GROUPEMENT_CHAIN_USER n'est attribue qu'au membre dont
 * l'acces a ete AUTORISE (interrupteur « Autoriser Ma centrale » de la liste d'equipe :
 * compte client CS-Cart lie ET actif). Sans lui, la section n'existe pas.
 */
export const routeFrontOfficeGroupementChainStore = [
  ...routeFrontOfficeAllEntityGroupementChainCommon,
  {
    route: 'GroupementStoreCatalog',
    text: 'Catalogue',
    t: 'routes.frontoffice.groupement.storeCatalog',
    href: '/industryoffice/groupement-chain/store',
    icon: StorefrontOutlinedIcon,
    menuHeader: true,
    position: 10,
    // France uniquement : le perimetre pays d'un utilisateur de groupement est celui de SA
    // fiche (`dataMyProfile.countries` est vide hors admin). Plus de feature flag (07/09/2026).
    fnDisplay: ({ dataMyProfile }) => isCompanyCountryFrance(dataMyProfile?.selectCompanyDefault),
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISTORE],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_GROUPEMENT_CHAIN_USER],
}))

export default routeFrontOfficeGroupementChainStore
